import React from 'react'
import { useTranslation } from 'next-i18next'

type Co2ScoreProps = {
  score: number
}

export default function Co2Score({ score }: Co2ScoreProps) {
  const { t } = useTranslation('originals/property')

  const Co2Component = (globalScore: number) => {
    if (globalScore <= 5) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-purple-300">
          <div className="mx-auto font-bold text-white">A</div>
        </div>
      )
    }

    if (globalScore >= 6 && globalScore <= 10) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-purple-400">
          <div className="mx-auto font-bold text-white">B</div>
        </div>
      )
    }

    if (globalScore >= 11 && globalScore <= 29) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-purple-500">
          <div className="mx-auto font-bold text-white">C</div>
        </div>
      )
    }

    if (globalScore >= 30 && globalScore <= 49) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-purple-600">
          <div className="mx-auto font-bold text-white">D</div>
        </div>
      )
    }

    if (globalScore >= 50 && globalScore <= 69) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-purple-700">
          <div className="mx-auto font-bold text-white">E</div>
        </div>
      )
    }

    if (globalScore >= 70 && globalScore <= 99) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-purple-800">
          <div className="mx-auto font-bold text-white">F</div>
        </div>
      )
    }

    if (globalScore >= 100) {
      return (
        <div className="flex h-7 w-7 items-center rounded-lg bg-purple-900">
          <div className="mx-auto font-bold text-white">G</div>
        </div>
      )
    }

    return <></>
  }

  return (
    <div className="flex items-center">
      {Co2Component(score)}
      <div className="ml-2 flex items-center">
        <div className="font-bold text-neutralBlack">{score}</div>
        <div className="ml-1 text-xs font-thin text-neutralBlack">
          {t('dpeAndWorkSection.dpe.kgeqCO2')}
        </div>
      </div>
    </div>
  )
}
